export default "__VITE_ASSET__ZKqqjZFR42UTR3PiSkCOqw__"